import { render, staticRenderFns } from "./registrationRecord.vue?vue&type=template&id=225634ec&scoped=true&"
import script from "./registrationRecord.vue?vue&type=script&lang=js&"
export * from "./registrationRecord.vue?vue&type=script&lang=js&"
import style0 from "./registrationRecord.vue?vue&type=style&index=0&id=225634ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225634ec",
  null
  
)

export default component.exports